"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVE_DIACRITICS = void 0;
exports.REMOVE_DIACRITICS = {
    alias: 'REMOVER_ACENTOS',
    description: 'Remove acentos de um valor',
    arg_names: ['valor', 'soltos'],
    args_description: ['string com acentos', 'limpar acentos soltos? (padrão=verdadeiro)'],
};
